export default function Groep(options) {
  this.key = { key: options.key };
  this.naam = options.naam;
  this.omschrijving = options.omschrijving;
  this.jaargroep = {
    key: options.jaargroep,
    naam: `${options.jaargroep}`,
  };
}
